import { useState } from 'react';
import { useIntl } from 'react-intl';
import { ButtonUI, Input } from 'sonata-react-components';

import { useMultiFlightMap } from '../../../../MultiFlightMap.context';
import { useMapPopover } from '../../../MapPopover/MapPopover.context';
import { VenueNamePopOverStyled } from './VenueNamePopOver.styled';

type State = {
  inputName: string | FileList | null;
};

type Props = {
  onClearPositions?: () => void;
  position?: { latitude: number; longitude: number } | null;
};

export function VenueNamePopOver({ onClearPositions, position }: Props) {
  const { formatMessage } = useIntl();
  const { closeMapPopover } = useMapPopover();
  const { addVenue } = useMultiFlightMap();

  const [{ inputName }, setState] = useState<State>({
    inputName: 'My new venue'
  });

  const handleQuitButton = () => {
    closeMapPopover();
  };

  const handleAddButton = async () => {
    if (position && inputName) {
      const venueName = typeof inputName === 'string' ? inputName : '';
      closeMapPopover();
      await addVenue(position.latitude, position.longitude, venueName);
      onClearPositions?.();
    }
  };

  const handleInputChange = (value: string | FileList | null) => {
    setState(prevState => ({
      ...prevState,
      inputName: value
    }));
  };

  return (
    <VenueNamePopOverStyled className="venueNamePopOver">
      <Input
        className="venueNamePopOver__input"
        defaultValue={inputName}
        id="venueNamePopOver-input"
        name="venueNamePopOver-input"
        notFloatingPlaceholder
        onChange={handleInputChange}
        shape="squareUI"
        tiny
        type="text"
      />
      <div className="venueNamePopOver__buttonsContainer">
        <ButtonUI
          icon="fal fa-xmark"
          onClick={handleQuitButton}
          size="ultraSmall"
          text={formatMessage({
            defaultMessage: 'Quit',
            id: 'common.quit'
          })}
          type="tertiary"
        />
        <ButtonUI
          className="venueNamePopOver__acceptButton"
          icon="fal fa-plus"
          onClick={handleAddButton}
          size="ultraSmall"
          text={formatMessage({
            defaultMessage: 'Add Venue',
            id: 'multiFlightVenues.venue'
          })}
        />
      </div>
    </VenueNamePopOverStyled>
  );
}
